var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666668 0H11.3333C11.7015 0 12 0.298477 12 0.666667V1.44667C12.0003 1.80203 11.8587 2.1428 11.6067 2.39333L7.72667 6.27333C7.47464 6.52386 7.33305 6.86464 7.33333 7.22V9.66667C7.33333 10.0863 7.13574 10.4815 6.8 10.7333L5.2 11.9333C5.099 12.0091 4.96386 12.0213 4.85093 11.9648C4.738 11.9083 4.66667 11.7929 4.66667 11.6667V7.22C4.66695 6.86464 4.52536 6.52386 4.27333 6.27333L0.393334 2.39333C0.141308 2.1428 -0.000280747 1.80203 4.17951e-07 1.44667V0.666667C4.17951e-07 0.298477 0.298478 0 0.666668 0ZM8.78 3.33333L10.6667 1.44667V1.33333H1.33333V1.44667L3.22 3.33333H8.78Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.6cf4df916a918d921c15bc45958c7f8d.svg";
export { ForwardRef as ReactComponent };